import { ACCOUNT_BAN_TYPES } from '~/constants';

import type { ICurrentAccountState } from '~/Reducers/ReducerCurrentAccount';
import type { IClanMember } from '~/types/declaration';

export const isChatDenied = (...accounts: Array<ICurrentAccountState | IClanMember>) => {
  return accounts.some((account) => account?.bans?.includes(ACCOUNT_BAN_TYPES.CHAT_DENIED));
};
